import { range } from 'lodash';

const randomInteger = (limit) => Math.floor(Math.random() * limit);
const randomHexadecimal = () => randomInteger(16).toString(16).toUpperCase();
const randomHexadecimals = (n) => range(n).map(randomHexadecimal).join('');
export default () => `TXID+${randomHexadecimals(20)}`;
